module.exports = __webpack_public_path__ + "img/icon-onlineShop.bb3d6914.svg";